import React, { useEffect, useState } from 'react';
import { MdOutlineArrowCircleLeft } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from '../axiosService/apiCall';

function Viewhistory() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get("userId");
    const adminId= queryParams.get("adminId")

    const [data, setData] = useState([]); // Stores filtered reward details
    const [originalData, setOriginalData] = useState([]); // Stores unfiltered data
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        try {
            let params = {
                url: `getuserviewlevelincomehistory?viewid=${userId||adminId}`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log(response, "response");

            if (response.status === true && response.userviewlevelincomehistory) {
                setData(response.userviewlevelincomehistory);
                setOriginalData(response.userviewlevelincomehistory); // Store original data for filtering
            } else {
                setData([]);
                setOriginalData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Handle search functionality
    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        setResetPaginationToggle(!resetPaginationToggle);

        if (value) {
            const filteredResults = originalData.filter(item =>
                item.email && item.email.toLowerCase().includes(value) // ✅ Check if email exists
            );
            setData(filteredResults);
        } else {
            setData(originalData);
        }
    };

    // Table columns
    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Reward Date',
            selector: row => row.RewardDate 
                ? new Date(row.RewardDate).toLocaleString('en-IN', { 
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    second: '2-digit', 
                    hour12: true, // To show AM/PM
                    timeZone: 'Asia/Kolkata' // Ensures IST time zone
                }) 
                : "N/A",
            sortable: true,
            width: '300px',

        },
        
        {
            name: 'Email',
            selector: row => row.email || "N/A", // ✅ Handle missing email
            sortable: true,
        },
        {
            name: 'Investing Amount',
            selector: row => row.investingamount || "N/A",
            sortable: true,
            width: '200px',

        },
        {
            name: 'Reward Amount',
            selector: row => row.rewardAmount || "N/A",
            sortable: true,
            width: '200px',

        },
        {
            name: 'Commission Percentage',
            selector: row => row.commissionpercentage || "N/A",
            sortable: true,
            width: '300px',

        },
    ];

    return (
        <div className='App'>
            <div className='container-fluid'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='row'>
                                <div className='col-md-12 ms-sm-auto col-lg-12 px-md-4 m-0 p-0'>
                                    <div className='custom-saled-order text-dark ms-3'>
                                        <div className="py-3 d-flex justify-content-between">
                                            <h3 className="component-user">
                                                <a className='me-3' href='/user-level-income-history'>
                                                    <MdOutlineArrowCircleLeft />
                                                </a>
                                                View History
                                            </h3>
                                        </div>

                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <input
                                                    type="text"
                                                    placeholder="Search by Email"
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                    className='form-search mb-4'
                                                />

                                                <div className='custom-datascroll'>
                                                    <DataTable
                                                        columns={columns}
                                                        data={data} // ✅ Use filtered data
                                                        theme="solarized"
                                                        pagination
                                                        paginationResetDefaultPage={resetPaginationToggle}
                                                        highlightOnHover
                                                        dense
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Viewhistory;
